  class CustomDesplegable extends HTMLElement {
    constructor() {
      super();
      this.toggle = this.querySelector('.custom-desplegable__toggle');
      this.content = this.querySelector('.custom-desplegable__content');
      this.header = this.querySelector('.custom-desplegable__header');
      this.isDesktop = window.innerWidth >= 1025;
      
      // Bind methods to preserve context
      this.toggleContent = this.toggleContent.bind(this);
      this.handleResize = this.handleResize.bind(this);
      
      this.init();
    }

    init() {
      if (this.isDesktop) {
        this.setupDesktop();
      } else {
        this.setupMobile();
      }

      // Escuchar cambios de tamaño de ventana
      window.addEventListener('resize', this.handleResize);
    }

    setupMobile() {
      // Limpiar event listeners anteriores
      this.cleanupEventListeners();
      
      this.toggle.style.display = 'flex';
      this.header.addEventListener('click', this.toggleContent);
      this.content.classList.remove('is-open');
      this.toggle.setAttribute('aria-expanded', 'false');
    }

    setupDesktop() {
      // Limpiar event listeners anteriores
      this.cleanupEventListeners();
      
      this.toggle.style.display = 'none';
      this.content.classList.add('is-open');
      this.toggle.setAttribute('aria-expanded', 'true');
    }

    cleanupEventListeners() {
      // Remover event listeners anteriores para evitar duplicados
      this.header.removeEventListener('click', this.toggleContent);
    }

    toggleContent() {
      const isExpanded = this.toggle.getAttribute('aria-expanded') === 'true';
      
      if (isExpanded) {
        this.closeContent();
      } else {
        this.openContent();
      }
    }

    openContent() {
      this.content.classList.add('is-open');
      this.toggle.setAttribute('aria-expanded', 'true');
    }

    closeContent() {
      this.content.classList.remove('is-open');
      this.toggle.setAttribute('aria-expanded', 'false');
    }

    handleResize() {
      const wasDesktop = this.isDesktop;
      this.isDesktop = window.innerWidth >= 1025;

      if (wasDesktop !== this.isDesktop) {
        if (this.isDesktop) {
          this.setupDesktop();
        } else {
          this.setupMobile();
        }
      }
    }

    disconnectedCallback() {
      // Limpiar event listeners cuando el elemento se remueve del DOM
      this.cleanupEventListeners();
      window.removeEventListener('resize', this.handleResize);
    }
  }

  // Registrar el web component
  customElements.define('custom-desplegable', CustomDesplegable);
